<template>
  <div>
    <div class="tile is-ancestor has-text-centered">
      <div class="tile is-parent">
        <article class="tile is-child box">
          <h4 class="title ">File Upload</h4>
          <div>
            <button class="button is-primary" v-on:click="$upload.select('file-upload')"
                    :disabled="$upload.meta('file-upload').status === 'sending'">
              <i class="fa fa-file"></i> &nbsp;<span v-show="$upload.meta('file-upload').status === 'sending'">Uploading...</span>
              <span v-show="$upload.meta('file-upload').status != 'sending'">Select</span>
            </button>

            <button class="button is-primary" v-on:click="$upload.reset('file-upload')"
                    :disabled="$upload.meta('file-upload').status === 'sending'">
              Clear
            </button>

          </div>
          <br/>
          <progress-bar :type="'success'" :value="$upload.meta('file-upload').percentComplete"
                        :max="100"></progress-bar>
          <br/>
          <div v-if="$upload.errors('file-upload').length" class="text-danger">
            {{ $upload.errors('file-upload')[0].message }}
          </div>
          <div>
            <div v-if="!$upload.files('file-upload').all.length">
              No uploads here yet.
            </div>

            <div v-for="file in $upload.files('file-upload').progress">
              <div>
                {{ file.name }}
              </div>

              <div class="progress">
                <div class="progress-bar" :style="'width: ' + file.percentComplete + '%;'">
                  {{ file.percentComplete }}%
                </div>
              </div>
            </div>

            <div v-for="file in $upload.files('file-upload').queued">
              <div>
                {{ file.name }}
                <br/>
                Queued for upload
              </div>
            </div>
            <table class="table is-striped is-narrow">
              <thead>
              <tr>
                <th>Name</th>
                <th>Status</th>
                <th>Link</th>
                <th></th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="file in $upload.files('file-upload').complete">
                <td>
                  {{ file.name }}
                </td>
                <td>
                  {{ file.status }}
                </td>
                <td v-if="file.status == 'success'"><a :href="file.downurl" data-label="Copied" class="short-link">https://flb.st/{{ file.randname }}</a></td>
                <td v-else></td>
                <td v-if=" file.status == 'success' "> {{ file.percentComplete }}%</td>
                <td v-else>
                 <span v-for="filerror in file.errors">
                    <span>  {{ filerror.message }} <br/></span>
                 </span>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </article>
      </div>
    </div>
  </div>
</template>

<script>
  import ProgressBar from 'vue-bulma-progress-bar'
  export default {
    components: {
      ProgressBar
    },
    created () {
      this.$upload.new('file-upload', {
        url: '/api/v1/upload',
        async: true,
        maxFiles: 20,
        multiple: true,
        onStart () {
//          this.$toggle.show('product:media:uploads')
        },
        onSuccess (res) {
        },
        onEnd () {
          // lol
        }
      })
    },
    mounted () {
      this.$upload.reset('file-upload', {
        dropzoneId: 'file-upload-dropzone'
      })
    },
    beforeDestroy () {
      this.$upload.reset('file-upload', {
        dropzoneId: null
      })
    },
    methods: {
      copyUrl (text) {
        console.log(text)
        let copyText = 'https://flb.st/' + text
        console.log(copyText)
        let mark, selection, range
        try {
          let range = document.createRange()
          let selection = document.getSelection()

          mark = document.createElement('span')
          mark.textContent = copyText
          // reset user styles for span element
          mark.style.all = 'unset'
          // prevents scrolling to the end of the page
          mark.style.position = 'fixed'
          mark.style.top = 0
          mark.style.clip = 'rect(0, 0, 0, 0)'
          // used to preserve spaces and line breaks
          mark.style.whiteSpace = 'pre'
          // do not inherit user-select (it may be `none`)
          mark.style.webkitUserSelect = 'text'
          mark.style.MozUserSelect = 'text'
          mark.style.msUserSelect = 'text'
          mark.style.userSelect = 'text'

          document.body.appendChild(mark)

          range.selectNode(mark)
          selection.addRange(range)

          let successful = document.execCommand('copy')
          if (!successful) {
            throw new Error('copy command was unsuccessful')
          }
        } catch (err) {
          try {
            window.clipboardData.setData('text', copyText)
          } catch (err) {
            console.log('unable to copy')
          }
        } finally {
          if (selection) {
            if (typeof selection.removeRange === 'function') {
              selection.removeRange(range)
            } else {
              selection.removeAllRanges()
            }
          }
          let d = document.getElementsByClassName('short-link')
          d[0].className += ' copying'
          setTimeout(function () {
            d[0].className = 'short-link'
          }, 500)
          mark.blur()
          if (mark) {
            document.body.removeChild(mark)
          }
        }
      }
    }
  }
</script>

<style lang="scss">
  .short-link {
    color: #00d1b2;
    cursor: pointer;
    text-decoration: none;
    transition: none 86ms ease-out;
    position: relative;
  }

  .short-link::after {
    content: attr(data-label);
    color: #00d1b2;
    display: inline-block;
    position: absolute;
    top: -2px;
    left: 50%;
    opacity: .001;
    text-align: center;
    -webkit-transform: translate3d(-50%, 0, 0);
    transform: translate3d(-50%, 0, 0);
    -webkit-backface-visibility: hidden;
    white-space: nowrap
  }

  .short-link.copying::after {
    -webkit-animation: floatup .5s ease-in-out;
    animation: floatup .5s ease-in-out
  }
</style>



// WEBPACK FOOTER //
// Upload.vue?04af8569